import FeedsList from "./List";
import FeedsEdit from "./Edit";
export default [
    { exact: true, path: "/feeds", component: FeedsList },
    { path: "/feeds/c", component: FeedsEdit },
    { path: "/feeds/e/:id", component: FeedsEdit }
];
